import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

type Step = 'details' | 'otp';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { sendOtp, verifyOtp, loginAsGuest } = useAuth();

  const [step,     setStep]     = useState<Step>('details');
  const [fullName, setFullName] = useState('');
  const [email,    setEmail]    = useState('');
  const [mobile,   setMobile]   = useState('');
  const [otp,      setOtp]      = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  const from = (location.state as any)?.from?.pathname || '/app';

  const handleSendOtp = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await sendOtp(fullName, email, mobile);
      setStep('otp');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await verifyOtp(email, otp);
      navigate(from, { replace: true });
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGuest = () => { loginAsGuest(); navigate('/app', { replace: true }); };

  return (
    <div className="login-page">
      <div className="login-card card">
        <div className="login-logo">🏭 TwinMaker<span>SaaS</span></div>
        <h2>{step === 'details' ? 'Welcome' : 'Verify OTP'}</h2>
        <p>{step === 'details' ? 'Enter your details to receive a one-time password' : `OTP sent to ${email}`}</p>

        {error && <div className="login-error">{error}</div>}

        {step === 'details' ? (
          <form onSubmit={handleSendOtp}>
            <div className="form-group">
              <label>Full Name</label>
              <input type="text" placeholder="John Smith" value={fullName}
                onChange={e => { setFullName(e.target.value); setError(''); }} required />
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" placeholder="you@company.com" value={email}
                onChange={e => { setEmail(e.target.value); setError(''); }} required />
            </div>
            <div className="form-group">
              <label>Mobile Number</label>
              <input type="tel" placeholder="+1 555 000 0000" value={mobile}
                onChange={e => { setMobile(e.target.value); setError(''); }} required />
            </div>
            <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? 'Sending OTP…' : 'Send OTP'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerifyOtp}>
            <div className="form-group">
              <label>6-digit OTP</label>
              <input type="text" placeholder="123456" value={otp} maxLength={6}
                onChange={e => { setOtp(e.target.value); setError(''); }}
                autoFocus required />
            </div>
            <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? 'Verifying…' : 'Verify & Sign In'}
            </button>
            <button type="button" className="btn-secondary" style={{ width: '100%', marginTop: 10 }}
              onClick={() => { setStep('details'); setOtp(''); setError(''); }}>
              ← Back
            </button>
          </form>
        )}


      </div>
    </div>
  );
};

export default Login;
